module.exports = __webpack_public_path__ + "static/media/Grand-Hotel.70420de4.svg";